module.exports = __webpack_public_path__ + "static/media/cq_scarica_pdf_nero.ef7f4567.svg";